import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./components/App";
import { store } from "wvus-sponsorship-engine";
import "./assets/less/main.less";

const container = document.getElementById("sponsorship-wrapper");

const root = createRoot(container);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
